import { RequestService } from "../../../../common/services/RequestService";
import { GET_COMPANY_INFO } from "../constants";

export const getCompanyInfoRequest = async companyId => {
  const response = await RequestService.get(GET_COMPANY_INFO.replace('{company_id}', companyId) );
  return response.data
};
